import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

const DashboardLayout = (props) => {
  return (
    <>
      <main className="h-screen overflow-auto bg-gray-100 dark:bg-gray-800">
        <div className="flex items-start justify-between">
          <Sidebar />
          <div className="flex flex-col w-full pl-0 md:p-4 md:space-y-4">
            <Header />
            <div className="h-screen pt-2 pb-24 pl-2 pr-2 overflow-auto md:pt-0 md:pr-0 md:pl-0">
              <div className="flex flex-col flex-wrap sm:flex-row ">
                {props.children}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default DashboardLayout;
